import axios from 'axios';
import { IDashboardActivity } from '@/dashboard/types/dashboard-activity';

export class DashboardService {
  static async getActivity({ showAll }: { showAll: boolean }): Promise<IDashboardActivity[]> {
    const body = new FormData();
    body.append('showall', `${showAll}`);

    const { data } = await axios.post('/get/board/activity', body);

    if (!data?.activity) {
      return [];
    }
    return data.activity.map(activityItem => {
      return {
        createdAt: activityItem.created_at,
        documentId: activityItem.document_id,
        documentName: activityItem.document_name,
        documentStatus: activityItem.document_status,
        eventMetadata: activityItem.event_meta_data,
        eventName: activityItem.event_name,
        firstName: activityItem.first_name,
        lastName: activityItem.last_name,
        thumbUrl: activityItem.thumb_url,
        companyName: activityItem.company_name,
      };
    });
  }
}
